import React from "react";
import './Style.css';

//https://www.w3schools.com/howto/howto_css_fixed_footer.asp
export default function Footer() {
  return <footer className="footer">
      <div>If you used this and like it please consider sending something to <span className="bold">0x000f8844053cF3562D28A8fD7b69Fe5102f6F0dB</span></div>
      <div>Not responsible for any issues | This website doesn't collect or share any information.</div>
    </footer>
}